import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { IApiError } from '../../../../react-core/Core/ApiError';
import { AccountTransferInstruction } from '../../../Models/Models/Transfer/AccountTransferInstruction';
import { InterAccountTransferErrors } from '../../../Validation/Errors/Transfer/InterAccount/InterAccountTransferErrors';

declare var IS_RUNNING_IN_APP_POOL;

export class AccountTransferClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(requestId: number): Promise<AccountTransferInstruction, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transfer/AccountTransfer/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { requestId: requestId }

    return AjaxWrapper.get<AccountTransferInstruction, any>(url, data);
  }
  public post(instruction: AccountTransferInstruction): Promise<AccountTransferInstruction, IApiError<InterAccountTransferErrors>[]> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transfer/AccountTransfer/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instruction: instruction }

    return AjaxWrapper.post<AccountTransferInstruction, IApiError<InterAccountTransferErrors>[]>(url, data);
  }
}

